import { CPC_DECILE_COLORS, CVR_HEATMAP_COLORS, DAYS_INVENTORY_HEATMAP_COLORS, BUYBOX_HEATMAP_COLORS, BEST_POSITION_HEATMAP_COLORS, KEYWORD_BID_HEATMAP_COLORS, SEARCH_FUNNEL_CVR_HEATMAP_COLORS, SEARCH_FUNNEL_CTR_HEATMAP_COLORS } from "@/utils/constants";
export const XXLARGE_COLUMN_WIDTH = "308px";
export const XLARGE_COLUMN_WIDTH = "255px";
export const LARGE_COLUMN_WIDTH = "200px";
export const MEDIUM_COLUMN_WIDTH = "115px";
export const SMALL_COLUMN_WIDTH = "82px";
export const TINY_COLUMN_WIDTH = "62px";
export const VERY_TINY_COLUMN_WIDTH = "32px";
export const SUPER_TINY_COLUMN_WIDTH = "16px";
export const WIDTH_450 = "450px";
export const WIDTH_240 = "240px";
export const WIDTH_220 = "220px";
export const WIDTH_215 = "215px";
export const WIDTH_205 = "205px";
export const WIDTH_170 = "170px";
export const WIDTH_168 = "168px";
export const WIDTH_164 = "164px";
export const WIDTH_150 = "150px";
export const WIDTH_149 = "149px";
export const WIDTH_140 = "140px";
export const WIDTH_138 = "138px";
export const WIDTH_130 = "130px";
export const WIDTH_124 = "124px";
export const WIDTH_115 = "115px";
export const WIDTH_109 = "109px";
export const WIDTH_108 = "108px";
export const WIDTH_100 = "100px";
export const WIDTH_96 = "96px";
export const WIDTH_80 = "80px";
export const WIDTH_76 = "76px";
export const WIDTH_66 = "66px";
export const SPEND_FIELD = {
  key: "spend",
  label: "Spend",
  type: "currency",
  threshold: {
    bad: 0.3,
    good: 0.7
  },
  thStyle: {
    minWidth: LARGE_COLUMN_WIDTH
  }
};
export const BIG_SPEND_FIELD = {
  key: "big_spend",
  label: "Spend",
  type: "currency",
  class: "right",
  justify: "flex-end",
  threshold: {
    bad: 0.3,
    good: 0.7
  },
  thStyle: {
    width: XLARGE_COLUMN_WIDTH
  }
};
export const TACOS_FIELD = {
  key: "TACOS",
  label: "TACOS",
  type: "percentage",
  class: "right",
  justify: "flex-end",
  threshold: {
    bad: 0.5,
    good: 1.0
  },
  thStyle: {
    minWidth: SMALL_COLUMN_WIDTH
  }
};
export const RATING_FIELD = {
  key: "rating",
  label: "Rating",
  type: "number",
  class: "right",
  justify: "flex-end",
  threshold: {
    bad: 0.5,
    good: 1.0
  },
  thStyle: {
    width: SMALL_COLUMN_WIDTH
  }
};
export const RATING_TOTAL_FIELD = {
  key: "ratings_total",
  label: "Reviews",
  type: "number",
  class: "right",
  justify: "flex-end",
  threshold: {
    bad: 0.5,
    good: 1.0
  },
  thStyle: {
    width: SMALL_COLUMN_WIDTH
  }
};
export const CVR_FIELD = {
  key: "CVR",
  label: "CVR",
  type: "percentage",
  class: "right",
  justify: "flex-end",
  heatmap_ranges: CVR_HEATMAP_COLORS,
  thStyle: {
    minWidth: VERY_TINY_COLUMN_WIDTH
  }
};
export const DAYS_INVENTORY_FIELD = {
  key: "days_inventory",
  label: "Days of inventory",
  type: "number",
  class: "left",
  justify: "flex-start",
  heatmap_ranges: DAYS_INVENTORY_HEATMAP_COLORS,
  thStyle: {
    minWidth: MEDIUM_COLUMN_WIDTH
  }
};
export const ORGANIC_SALES_FIELD = {
  key: "organic_sales",
  label: "Organic sales",
  type: "number",
  class: "left",
  justify: "flex-start",
  thStyle: {
    minWidth: WIDTH_164
  }
};
export const ORGANIC_CVR_FIELD = {
  key: "organic_CVR",
  label: "CVR",
  type: "percentage",
  class: "right",
  justify: "flex-end",
  heatmap_ranges: CVR_HEATMAP_COLORS,
  thStyle: {
    minWidth: VERY_TINY_COLUMN_WIDTH
  }
};
export const CPC_FIELD = {
  key: "CPC",
  label: "CPC",
  type: "currency",
  class: "right",
  justify: "flex-end",
  thStyle: {
    minWidth: VERY_TINY_COLUMN_WIDTH
  },
  heatmap_ranges: CPC_DECILE_COLORS
};
export const CTR_FIELD = {
  key: "CTR",
  label: "CTR",
  type: "percentage",
  class: "right",
  justify: "flex-end",
  heatmap_ranges: CVR_HEATMAP_COLORS,
  thStyle: {
    minWidth: VERY_TINY_COLUMN_WIDTH
  }
};
export const SPONSORED_ASIN_FIELD = {
  key: "sponsored_asin",
  label: "Spons. ASIN",
  thStyle: {
    width: SMALL_COLUMN_WIDTH
  }
};
export const PAGE_VIEWS_FIELD = {
  key: "page_views",
  label: "Page views",
  type: "number",
  thStyle: {
    width: LARGE_COLUMN_WIDTH
  }
};
export const RETURN_RATE_FIELD = {
  key: "return_rate",
  label: "Return rate",
  type: "percentage",
  thStyle: {
    minWidth: MEDIUM_COLUMN_WIDTH
  }
};
export const PPC_SALES_FIELD = {
  key: "share_sponsored_sales",
  label: "% of PPC sales",
  type: "percentage",
  thStyle: {
    width: MEDIUM_COLUMN_WIDTH
  }
};
export const UNITS_SOLD_FIELD = {
  key: "units_sold_clicks_14_d",
  label: "Units Sold",
  type: "number",
  class: "right",
  justify: "flex-end",
  threshold: {
    bad: 0.3,
    good: 0.5
  },
  thStyle: {
    width: SMALL_COLUMN_WIDTH
  }
};
export const CLICKS_FIELD = {
  key: "clicks",
  label: "Clicks",
  type: "number",
  class: "right",
  justify: "flex-end",
  threshold: {
    bad: 0.3,
    good: 0.5
  },
  thStyle: {
    minWidth: TINY_COLUMN_WIDTH
  }
};
export const IMPRESSIONS_FIELD = {
  key: "impressions",
  label: "Impressions",
  type: "number",
  class: "right",
  justify: "flex-end",
  threshold: {
    bad: 0.3,
    good: 0.5
  },
  thStyle: {
    minWidth: TINY_COLUMN_WIDTH
  }
};
export const SPONSORED_SALES_FIELD = {
  key: "sponsored_sales",
  label: "Sponsored Sales",
  type: "currency",
  threshold: {
    bad: 0.3,
    good: 0.5
  },
  thStyle: {
    minWidth: LARGE_COLUMN_WIDTH
  }
};
export const BIG_SPONSORED_SALES_FIELD = {
  key: "big_sponsored_sales",
  label: "Sponsored Sales",
  type: "currency",
  class: "right",
  justify: "flex-end",
  threshold: {
    bad: 0.3,
    good: 0.5
  },
  thStyle: {
    minWidth: XLARGE_COLUMN_WIDTH
  }
};
export const REVENUE_EXCL_VAT_FIELD = {
  key: "revenue_excl_VAT",
  label: "Revenue excl. VAT",
  type: "currency",
  threshold: {
    bad: 0.3,
    good: 0.5
  },
  thStyle: {
    minWidth: XLARGE_COLUMN_WIDTH
  }
};
export const BEST_POSITION_FIELD = {
  key: "best_position",
  label: "Best pos<sup>n</sup>",
  type: "number",
  class: "center",
  justify: "center",
  thStyle: {
    minWidth: TINY_COLUMN_WIDTH
  },
  heatmap_ranges: BEST_POSITION_HEATMAP_COLORS
};
export const BUYBOX_FIELD = {
  key: "traffic_by_asin_buy_box_percentage",
  label: "% of buybox",
  type: "percentage",
  class: "center",
  justify: "center",
  thStyle: {
    minWidth: TINY_COLUMN_WIDTH
  },
  heatmap_ranges: BUYBOX_HEATMAP_COLORS
};
export const CAMPAIGN_BUDGET_FIELD = {
  key: "campaign_budget",
  label: "Daily Budget",
  type: "currency",
  justify: "flex-end",
  thStyle: {
    minWidth: TINY_COLUMN_WIDTH
  }
};
export const ROAS_FIELD = {
  key: "ROAS",
  label: "ROAS",
  type: "number",
  class: "center",
  justify: "center",
  threshold: {
    bad: 0.5,
    good: 1.0
  },
  thStyle: {
    minWidth: TINY_COLUMN_WIDTH
  }
};
export const TOTAL_ROAS_FIELD = {
  key: "total_ROAS",
  label: "Total ROAS",
  type: "number",
  class: ["roas-highlighted", "total-roas"],
  threshold: {
    bad: 0.5,
    good: 1.0
  },
  thStyle: {
    width: SMALL_COLUMN_WIDTH,
    ["--total-roas-width"]: TINY_COLUMN_WIDTH
  }
};
export const BAR_ROAS_FIELD = {
  key: "ROAS",
  label: "ROAS",
  type: "number",
  class: "left",
  justify: "flex-start",
  threshold: {
    bad: 0.5,
    good: 1.0
  },
  thStyle: {
    minWidth: TINY_COLUMN_WIDTH
  }
};
export const SELECTOR = {
  key: "selector",
  label: "",
  class: "center",
  thStyle: {
    width: SUPER_TINY_COLUMN_WIDTH
  },
  stickyColumn: true
};
export const PERIOD_FIELD = {
  key: "period_agg",
  label: "",
  stickyColumn: true,
  thStyle: {
    width: MEDIUM_COLUMN_WIDTH
  }
};
export const PPC_V2_PERIOD_FIELD = {
  key: "period_agg",
  label: "",
  stickyColumn: true,
  thStyle: {
    width: SMALL_COLUMN_WIDTH
  }
};
export const SKU_SOLD_FIELD = {
  key: "share_sku_sold",
  label: "% of SKUs sold",
  type: "percentage",
  class: "left",
  justify: "flex-start",
  thStyle: {
    minWidth: MEDIUM_COLUMN_WIDTH
  },
  heatmap_ranges: CPC_DECILE_COLORS
};
export const ASIN_SOLD_FIELD = {
  key: "share_asin_sold",
  label: "% of ASIN sold",
  type: "percentage",
  class: "left",
  justify: "flex-start",
  thStyle: {
    minWidth: MEDIUM_COLUMN_WIDTH
  },
  heatmap_ranges: CPC_DECILE_COLORS
};
export const REVENUE_SHARE_FIELD = {
  key: "share_total_revenue",
  label: "Rev. share",
  type: "percentage",
  class: "right",
  justify: "flex-end",
  thStyle: {
    minWidth: SMALL_COLUMN_WIDTH
  }
};
export const TOTAL_QUANTITY_FIELD = {
  key: "total_quantity",
  label: "Units Sold",
  type: "number",
  class: "right",
  justify: "flex-end",
  thStyle: {
    width: MEDIUM_COLUMN_WIDTH
  }
};
export const LISTED_ASIN_FIELD = {
  key: "listed_asin_count",
  label: "# active vs listed ASIN",
  type: "number",
  thStyle: {
    minWidth: LARGE_COLUMN_WIDTH
  }
};
export const CANNIBALIZATION_FIELD = {
  key: "cannibalization_pc",
  label: "Cannibal<sup>n</sup>",
  type: "percentage",
  class: "center",
  thStyle: {
    width: TINY_COLUMN_WIDTH
  }
};
export const TIME_IN_BUDGET_FIELD = {
  key: "percent_time_in_budget",
  label: "Time in budget",
  type: "percentage",
  class: "right",
  justify: "flex-end",
  thStyle: {
    minWidth: MEDIUM_COLUMN_WIDTH
  }
};
export const BIG_ROAS_FIELD = {
  key: "targeting_type_ROAS",
  label: "ROAS",
  type: "number",
  justify: "center",
  threshold: {
    bad: 0.5,
    good: 1.0
  },
  class: ["center", "roas-highlighted", "big-roas"],
  thStyle: {
    width: XLARGE_COLUMN_WIDTH
  }
};
export const BIG_CPC_FIELD = {
  key: "targeting_type_CPC",
  label: "CPC",
  type: "currency",
  justify: "center",
  threshold: {
    bad: 0.5,
    good: 1.0
  },
  class: ["center", "cpc-highlighted"],
  thStyle: {
    width: XLARGE_COLUMN_WIDTH
  }
};
export const TARGETING_TYPE_FIELD = {
  key: "targeting_type",
  label: "",
  class: "center",
  thStyle: {
    width: TINY_COLUMN_WIDTH
  }
};
export const MARKETPLACE_FIELD = {
  key: "sales_channel",
  label: "Marketplace",
  justify: "flex-start",
  thStyle: {
    minWidth: LARGE_COLUMN_WIDTH
  },
  stickyColumn: true
};
export const SELLER_FIELD = {
  key: "seller_name",
  label: "Seller Name",
  justify: "flex-start",
  thStyle: {
    minWidth: XLARGE_COLUMN_WIDTH
  },
  stickyColumn: true
};
export const PRODUCT_FIELD = {
  key: "product_name",
  label: "Product",
  justify: "flex-start",
  thStyle: {
    minWidth: XXLARGE_COLUMN_WIDTH
  },
  stickyColumn: true
};
export const CAMPAIGN_GROUP_FIELD = {
  key: "campaign_group_name",
  label: "Campaign group",
  justify: "flex-start",
  thStyle: {
    minWidth: XXLARGE_COLUMN_WIDTH
  },
  stickyColumn: true
};
export const CAMPAIGN_NAME_FIELD = {
  key: "campaign_name",
  label: "Campaign",
  justify: "flex-start",
  thStyle: {
    minWidth: XXLARGE_COLUMN_WIDTH
  },
  stickyColumn: true
};
export const TARGETING_FIELD = {
  key: "targeting",
  label: "Targeting",
  justify: "flex-start",
  thStyle: {
    minWidth: XXLARGE_COLUMN_WIDTH
  },
  stickyColumn: true
};
export const KEYWORD_BID_FIELD = {
  key: "keyword_bid",
  label: "Last Bid",
  type: "currency",
  justify: "flex-end",
  heatmap_ranges: KEYWORD_BID_HEATMAP_COLORS,
  thStyle: {
    minWidth: SMALL_COLUMN_WIDTH
  }
};
export const LOST_REVENUE_EXCL_VAT_FIELD = {
  key: "lost_revenue_excl_VAT",
  label: "Lost revenue",
  type: "currency",
  class: "right",
  justify: "flex-end",
  thStyle: {
    minWidth: SMALL_COLUMN_WIDTH
  }
};
export const PROFIT_REVENUE_FIELD = {
  key: "pl_net_revenue",
  label: "Revenue",
  type: "currency",
  thStyle: {
    width: XLARGE_COLUMN_WIDTH
  }
};
export const PROFIT_CONTRIBUTIVE_MARGIN_FIELD = {
  key: "pl_contributive_margin",
  label: "Net Margin",
  type: "currency",
  thStyle: {
    width: XLARGE_COLUMN_WIDTH
  }
};
export const PROFIT_PERCENTAGE_OF_REVENUE_FIELD = {
  key: "pl_net_percentage_revenue",
  label: "% of rev.",
  fullLabel: "% of revenue",
  type: "percentage",
  thStyle: {
    width: MEDIUM_COLUMN_WIDTH
  }
};
export const PROFIT_COMMISSION_FIELD = {
  key: "pl_amazon_commission_pc",
  label: "Commis...",
  fullLabel: "Amazon Commission",
  type: "percentage",
  class: "right",
  justify: "flex-end",
  thStyle: {
    width: TINY_COLUMN_WIDTH
  }
};
export const PROFIT_FBA_DIRECT_FIELD = {
  key: "pl_fba_direct_pc",
  label: "FBA direct",
  fullLabel: "FBA Direct Fees",
  type: "percentage",
  class: "right",
  justify: "flex-end",
  thStyle: {
    width: TINY_COLUMN_WIDTH
  }
};
export const PROFIT_FBA_INDIRECT_FIELD = {
  key: "pl_fba_indirect_pc",
  label: "FBA indir.",
  fullLabel: "FBA Indirect Fees",
  type: "percentage",
  class: "right",
  justify: "flex-end",
  thStyle: {
    width: TINY_COLUMN_WIDTH
  }
};
export const PROFIT_REFUND_FIELD = {
  key: "pl_refund_pc",
  label: "Ref. & G...",
  fullLabel: "Refunds & Guarantees",
  type: "percentage",
  class: "right",
  justify: "flex-end",
  thStyle: {
    width: TINY_COLUMN_WIDTH
  }
};
export const PROFIT_COOP_FIELD = {
  key: "pl_coop_pc",
  label: "Co-op",
  fullLabel: "Co-op Deductions",
  type: "percentage",
  class: "right",
  justify: "flex-end",
  thStyle: {
    width: TINY_COLUMN_WIDTH
  }
};
export const PROFIT_COGS_FIELD = {
  key: "pl_cogs_pc",
  label: "COGS",
  type: "percentage",
  class: "right",
  justify: "flex-end",
  thStyle: {
    width: TINY_COLUMN_WIDTH
  }
};
export const PROFIT_OTHER_COSTS_FIELD = {
  key: "pl_other_costs_pc",
  label: "Other",
  fullLabel: "Other Costs",
  type: "percentage",
  class: "right",
  justify: "flex-end",
  thStyle: {
    width: TINY_COLUMN_WIDTH
  }
};
export const PROFIT_ADVERTISING_COSTS_FIELD = {
  key: "pl_advertising_costs",
  label: "Advertising costs",
  type: "currency",
  thStyle: {
    width: LARGE_COLUMN_WIDTH
  }
};
export const AVERAGE_UNIT_PRICE_FIELD = {
  key: "avg_unit_price",
  label: "Avg unit price",
  type: "currency",
  thStyle: {
    width: MEDIUM_COLUMN_WIDTH
  },
  class: "right",
  justify: "flex-end"
};
export const AD_FORMAT_FIELD = {
  key: "ad_product",
  label: "Ad Format",
  thStyle: {
    width: LARGE_COLUMN_WIDTH
  },
  stickyColumn: true
};
export const SHARE_OF_VOICE_FIELD = {
  key: "share_of_voice",
  label: "Br. SoV",
  type: "percentage",
  thStyle: {
    width: TINY_COLUMN_WIDTH
  }
};
export const PRODUCT_SEGMENT_FIELD = {
  key: "product_segment",
  label: "Product",
  thStyle: {
    width: XXLARGE_COLUMN_WIDTH
  },
  stickyColumn: true
};
export const AVG_BSR_FIELD = {
  key: "avg_bsr",
  label: "Avg. BSR",
  type: "number",
  thStyle: {
    width: LARGE_COLUMN_WIDTH
  }
};
export const BIG_AVG_BSR_FIELD = {
  key: "avg_bsr",
  label: "Avg. BSR",
  type: "number",
  thStyle: {
    width: "210px"
  },
  class: "avg_bsr"
};
export const PRODUCT_BRAND_FIELD = {
  key: "brand",
  label: "Brand",
  thStyle: {
    width: XXLARGE_COLUMN_WIDTH
  },
  stickyColumn: true
};
export const MARKET_SIZE_FIELD = {
  key: "market_size",
  label: "Market size (Revenue)",
  type: "currency",
  class: ["left-embrace", "market"],
  justify: "left",
  thStyle: {
    width: LARGE_COLUMN_WIDTH
  }
};
export const MARKET_UNITS_SOLD_FIELD = {
  key: "market_units_sold",
  class: ["inner-embrace", "market"],
  label: "Market size (Units sold)",
  type: "number",
  justify: "center",
  thStyle: {
    width: LARGE_COLUMN_WIDTH
  }
};
export const AVERAGE_PRICE_MARKET_FIELD = {
  key: "avg_market_price",
  label: "Avg price",
  type: "currency",
  class: ["inner-embrace", "market"],
  justify: "right",
  thStyle: {
    width: WIDTH_76
  }
};
export const COMPETITOR_AVERAGE_PRICE_MARKET_FIELD = {
  key: "competitor_avg_market_price",
  label: "Avg price",
  type: "currency",
  class: ["market"],
  justify: "right",
  thStyle: {
    width: WIDTH_76
  }
};
export const PRICE_RANGE_FIELD = {
  key: "market_price_range",
  label: "Price range",
  type: "currency",
  class: ["inner-embrace", "market"],
  justify: "center",
  thStyle: {
    minWidth: LARGE_COLUMN_WIDTH
  }
};
export const AVERAGE_PRICE_SELLER_PERFORMANCE_FIELD = {
  key: "avg_seller_price",
  label: "Avg price",
  type: "currency",
  class: ["left-embrace", "seller_performance"],
  justify: "right",
  thStyle: {
    width: WIDTH_76
  }
};
export const SHARE_OF_UNITS_SOLD_FIELD = {
  key: "seller_share_of_units_sold",
  label: "Market share (Units sold)",
  type: "percentage",
  class: ["inner-embrace", "seller_performance"],
  justify: "center",
  thStyle: {
    width: WIDTH_205
  }
};
export const COMPETITOR_SHARE_OF_UNITS_SOLD_FIELD = {
  key: "competitor_seller_share_of_units_sold",
  label: "Market share (Units sold)",
  type: "percentage",
  class: ["seller_performance"],
  justify: "center",
  thStyle: {
    width: WIDTH_205
  }
};
export const MARKET_SHARE_FIELD = {
  key: "seller_market_share",
  label: "Market share (Revenue) ",
  type: "percentage",
  class: ["inner-embrace", "seller_performance"],
  justify: "left",
  thStyle: {
    width: WIDTH_170
  }
};
export const COMPETITOR_MARKET_SHARE_FIELD = {
  key: "competitor_seller_market_share",
  label: "Market share (Revenue) ",
  type: "percentage",
  class: ["seller_performance"],
  justify: "left",
  thStyle: {
    width: WIDTH_170
  }
};
export const RANK_FIELD = {
  key: "seller_market_share_rank",
  label: "Seller Rank",
  type: "number",
  class: ["left-embrace", "seller_performance"],
  justify: "center",
  thStyle: {
    width: WIDTH_66
  }
};
export const COMPETITOR_RANK_FIELD = {
  key: "competitor_seller_market_share_rank",
  label: "#",
  type: "number",
  class: ["seller_performance"],
  justify: "center",
  thStyle: {
    width: TINY_COLUMN_WIDTH
  }
};
export const RELATIVE_SHARE_VS_LEADER_FIELD = {
  key: "relative_marketshare_to_top_competitor",
  label: "Relative share vs. top competitor",
  type: "percentage",
  class: ["right-embrace", "market"],
  justify: "right"
  // thStyle: { width: WIDTH_215 },
};
export const RELATIVE_SHARE_VS_PRECEDING_FIELD = {
  key: "relative_marketshare_to_preceding_competitor",
  label: "Relative share vs. preceding",
  type: "percentage",
  class: ["inner-embrace", "seller_marketshare_positioning"],
  justify: "right",
  thStyle: {
    width: WIDTH_215
  }
};
export const BEST_BRAND_PRODUCT_RANK_FIELD = {
  key: "best_seller_product_rank",
  label: "Best product sales rank",
  type: "number",
  class: ["right-embrace", "seller_performance"],
  justify: "right",
  thStyle: {
    width: WIDTH_164
  }
};
export const CATEGORY_REVENUE_SHARE = {
  key: "category_revenue_share",
  label: "Rev. share",
  type: "percentage",
  class: ["inner-embrace", "category-revenue-share"],
  justify: "right",
  thStyle: {
    width: WIDTH_66
  },
  stickyColumn: true
};
export const RATINGS_FIELD = {
  key: "avg_seller_rating",
  label: "Ratings",
  type: "number",
  class: ["left-embrace", "seller_perception"],
  justify: "center",
  thStyle: {
    width: WIDTH_164
  }
};
export const REVIEWS_FIELD = {
  key: "avg_seller_rating_per_product",
  label: "Reviews",
  type: "number",
  class: ["right-embrace", "seller_perception"],
  justify: "center",
  thStyle: {
    width: WIDTH_140
  }
};
export const BRAND_REVENUE_FIELD = {
  key: "brand_revenue",
  label: "Est. Revenue",
  type: "number",
  justify: "center",
  thStyle: {
    width: MEDIUM_COLUMN_WIDTH
  }
};
export const BRAND_UNITS_SOLD_FIELD = {
  key: "brand_units_sold",
  label: "Est. Units sold",
  type: "number",
  justify: "center",
  thStyle: {
    width: MEDIUM_COLUMN_WIDTH
  }
};
export const CATEGORY_FIELD = {
  key: "category",
  label: "Category",
  class: ["no-border-right"],
  justify: "left",
  thStyle: {
    width: LARGE_COLUMN_WIDTH
  },
  stickyColumn: true
};
export const SEARCHES_FIELD = {
  key: "search_query_volume",
  label: "Searches",
  justify: "left",
  thStyle: {
    width: WIDTH_164
  }
};
export const SELLER_NOTORIETY_FIELD = {
  key: "seller_notoriety",
  label: "Brand searches",
  justify: "left",
  thStyle: {
    width: WIDTH_164
  }
};
export const BRAND_IMPRESSION_SHARE_FIELD = {
  key: "impression_share",
  label: "Impressions",
  justify: "left",
  thStyle: {
    minWidth: MEDIUM_COLUMN_WIDTH
  }
};
export const BRAND_IMPRESSION_FIELD = {
  key: "impression_count",
  label: "Impressions",
  justify: "left",
  thStyle: {
    width: WIDTH_164
  }
};
export const BRAND_CLICK_SHARE_FIELD = {
  key: "click_share",
  label: "Clicks",
  justify: "left",
  thStyle: {
    minWidth: MEDIUM_COLUMN_WIDTH
  }
};
export const BRAND_CLICK_FIELD = {
  key: "click_count",
  label: "Clicks",
  justify: "leftt",
  thStyle: {
    width: WIDTH_164
  }
};
export const BRAND_PURCHASE_SHARE_FIELD = {
  key: "purchase_share",
  label: "Purchases",
  class: "right_inset_shadow",
  justify: "left",
  thStyle: {
    minWidth: MEDIUM_COLUMN_WIDTH
  }
};
export const BRAND_PURCHASE_FIELD = {
  key: "purchase_count",
  label: "Purchases",
  justify: "left",
  thStyle: {
    width: WIDTH_164
  }
};
export const ORDERED_REVENUE_FIELD = {
  key: "ordered_revenue_amount",
  label: "Ordered Revenue",
  justify: "left",
  class: ["left-embrace", "sell_out"],
  thStyle: {
    width: MEDIUM_COLUMN_WIDTH
  }
};
export const SHIPPED_REVENUE_FIELD = {
  key: "shipped_revenue_amount",
  label: "Shipped Revenue",
  class: ["inner-embrace", "sell_out"],
  justify: "left",
  thStyle: {
    minWidth: XLARGE_COLUMN_WIDTH
  }
};
export const SHIPPED_COGS_FIELD = {
  key: "shipped_cogs_amount",
  label: "Shipped COGS",
  justify: "left",
  class: ["inner-embrace", "sell_out"],
  thStyle: {
    width: WIDTH_140
  }
};
export const CUSTOMER_RETURNS_FIELD = {
  key: "vendor_return_rate",
  label: "Return %",
  justify: "left",
  class: ["right-embrace", "sell_out"],
  thStyle: {
    width: MEDIUM_COLUMN_WIDTH
  }
};
export const NET_PPM_FIELD = {
  key: "net_ppm_amount",
  label: "Net PPM",
  justify: "right",
  thStyle: {
    width: WIDTH_66
  }
};
export const NET_PPM_PERCENTAGE_FIELD = {
  key: "net_ppm_pc",
  label: "Net PPM %",
  justify: "right",
  thStyle: {
    width: WIDTH_170
  }
};
export const NET_RECEIVED_UNITS_FIELD = {
  key: "net_received_inventory_cost_amount_eur",
  label: "Net Received Inventory",
  justify: "left",
  class: ["left-embrace", "right-embrace", "sell_in"],
  thStyle: {
    minWidth: WIDTH_240
  }
};
export const KEYWORD_TYPE_FIELD = {
  key: "search_query_type",
  label: "Keyword type",
  justify: "left",
  thStyle: {
    width: WIDTH_240
  },
  stickyColumn: true
};
export const KEYWORD_FIELD = {
  key: "search_query",
  label: "Keyword",
  justify: "left",
  thStyle: {
    minWidth: XLARGE_COLUMN_WIDTH
  },
  stickyColumn: true
};
export const SEARCH_FUNNEL_CVR_FIELD = {
  key: "conversion_rate",
  label: "CVR",
  type: "percentage",
  class: "right",
  justify: "flex-end",
  heatmap_ranges: SEARCH_FUNNEL_CVR_HEATMAP_COLORS,
  thStyle: {
    minWidth: VERY_TINY_COLUMN_WIDTH
  }
};
export const SEARCH_FUNNEL_CTR_FIELD = {
  key: "brand_ctr",
  label: "CTR",
  type: "percentage",
  class: "right",
  justify: "flex-end",
  heatmap_ranges: SEARCH_FUNNEL_CTR_HEATMAP_COLORS,
  thStyle: {
    minWidth: VERY_TINY_COLUMN_WIDTH
  }
};
export const SEARCH_SHARE_OF_REVENUE_FIELD = {
  key: "search_revenue_share",
  label: "Search share of rev.",
  type: "percentage",
  class: "left",
  justify: "flex-start",
  thStyle: {
    width: WIDTH_164
  }
};
export const SEARCH_FUNNEL_PURCHASES_SHARE_FIELD = {
  key: "purchases_share",
  label: "Purchases share",
  class: "left",
  justify: "flex-start",
  thStyle: {
    minWidth: WIDTH_170
  }
};
export const SEARCH_FUNNEL_TOP_PRODUCT_FIELD = {
  key: "top_product",
  label: "Top prod.",
  class: "left",
  justify: "flex-start",
  thStyle: {
    width: VERY_TINY_COLUMN_WIDTH
  }
};
export const SEARCH_FUNNEL_SHARE_OF_VOICE_FIELD = {
  key: "sf_share_of_voice",
  label: "Share of voice",
  class: "left sf-share-of-voice",
  justify: "flex-start",
  thStyle: {
    width: XXLARGE_COLUMN_WIDTH
  }
};
export const SEARCH_FUNNEL_BEST_POSITION_FIELD = {
  key: "sf_best_position",
  label: "Best position",
  class: "left",
  justify: "flex-start",
  thStyle: {
    width: WIDTH_115
  }
};
export const SEARCH_FUNNEL_SOV_SPONSORED_FIELD = {
  key: "sov_sponsored",
  label: "SOV Sponsored",
  class: "left",
  justify: "flex-start",
  thStyle: {
    width: WIDTH_170
  }
};
export const SEARCH_FUNNEL_NUMBER_OF_IMPRESSIONS_PER_SEARCH_FIELD = {
  key: "no_impressions_per_search",
  label: "#impressions per Search",
  class: "no_impressions_per_search",
  justify: "flex-start",
  thStyle: {
    width: WIDTH_164
  }
};
export const SEARCH_FUNNEL_CLICK_SHARE_FIELD = {
  key: "sf_click_share",
  label: "Click distribution",
  class: "no-border-right",
  justify: "flex-start",
  thStyle: {
    width: WIDTH_164
  }
};
export const SEARCH_FUNNEL_ESTMATED_OPPORTUNITY_FIELD = {
  key: "estimated_opportunity",
  label: "Estimated Opportunity",
  class: "left_shadow sf_estimated_opportunity",
  justify: "flex-start",
  stickyColumn: true,
  thStyle: {
    width: SMALL_COLUMN_WIDTH
  }
};
export const SEARCH_FUNNEL_OPPRTUNITIES_SEARCHES_FIELD = {
  key: "search_query_volume",
  label: "Search Volume",
  justify: "center",
  thStyle: {
    width: WIDTH_96
  }
};
export const DSP_ROAS_VS_TARGET_FIELD = {
  key: "dsp_roas_vs_target",
  label: "ROAS vs target",
  class: ["left-embrace", "efficiency"],
  justify: "center",
  thStyle: {
    width: WIDTH_124
  }
};
export const DSP_PERCENT_ASSISTED_SALES_FIELD = {
  key: "dsp_percent_assisted_sales",
  label: "% of assisted sales",
  class: ["inner-embrace", "business_results"],
  justify: "flex-start",
  thStyle: {
    width: WIDTH_140
  }
};
export const DSP_ECPM_FIELD = {
  key: "dsp_ecpm",
  label: "eCPM",
  class: ["left-embrace", "delivery_quality"],
  justify: "flex-start",
  thStyle: {
    width: VERY_TINY_COLUMN_WIDTH
  }
};
export const DSP_CAMPAIGN_FIELD = {
  key: "order_id",
  label: "Order name",
  class: "left",
  justify: "flex-start",
  thStyle: {
    minWidth: XLARGE_COLUMN_WIDTH
  },
  stickyColumn: true
};
export const DSP_LINE_ITEM_FIELD = {
  key: "line_item_id",
  label: "Line Item",
  class: "left",
  justify: "flex-start",
  thStyle: {
    minWidth: XLARGE_COLUMN_WIDTH
  },
  stickyColumn: true
};
export const DSP_NEW_CUSTOMERS_FIELD = {
  key: "dsp_new_customers",
  label: "New Customers",
  thStyle: {
    width: WIDTH_170
  },
  class: ["left-embrace", "right-embrace", "objective"]
};
export const DSP_CPA_CONVERSION_FIELD = {
  key: "dsp_cpa_conversion",
  label: "CPA",
  thStyle: {
    width: TINY_COLUMN_WIDTH
  },
  class: ["right-embrace", "efficiency"]
};
export const DSP_CPA_CONSIDERATION_FIELD = {
  key: "dsp_cpa_consideration",
  label: "CPA",
  thStyle: {
    width: TINY_COLUMN_WIDTH
  },
  class: ["right-embrace", "efficiency"]
};
export const DSP_CPA_LOYALTY_FIELD = {
  key: "dsp_cpa_loyalty",
  label: "CPA",
  thStyle: {
    width: TINY_COLUMN_WIDTH
  },
  class: ["right-embrace", "efficiency"]
};
export const DSP_SPEND_FIELD = {
  key: "dsp_spend",
  label: "Spend",
  thStyle: {
    width: WIDTH_100
  },
  justify: "flex-start",
  class: ["left-embrace", "business_results", "vs", "no-border-right"]
};
export const DSP_ASSISTED_SALES_FIELD = {
  key: "dsp_assisted_sales",
  label: "Assisted Sales",
  thStyle: {
    width: WIDTH_100
  },
  justify: "flex-end",
  class: ["inner-embrace", "business_results"]
};
export const DSP_UNITS_SOLD_FIELD = {
  key: "dsp_units_sold",
  label: "Units sold",
  thStyle: {
    width: WIDTH_124
  },
  class: ["right-embrace", "business_results"]
};
export const DSP_ATC_CLICKS_FIELD = {
  key: "dsp_atc_clicks",
  label: "ATC Clicks",
  thStyle: {
    width: WIDTH_100
  },
  justify: "flex-start",
  class: ["left-embrace", "brand_interest", "vs", "no-border-right"]
};
export const DSP_ATC_VIEWS_FIELD = {
  key: "dsp_atc_views",
  label: "ATC Views",
  thStyle: {
    width: WIDTH_100
  },
  justify: "flex-end",
  class: ["inner-embrace", "brand_interest"]
};
export const DSP_DPV_CLICKS_FIELD = {
  key: "dsp_dpv_clicks",
  label: "DPV Clicks",
  thStyle: {
    width: WIDTH_100
  },
  justify: "flex-start",
  class: ["inner-embrace", "brand_interest", "vs", "no-border-right"]
};
export const DSP_DPV_VIEWS_FIELD = {
  key: "dsp_dpv_views",
  label: "DPV Views",
  thStyle: {
    width: WIDTH_100
  },
  justify: "flex-end",
  class: ["inner-embrace", "brand_interest"]
};
export const DSP_BRAND_SEARCHES_FIELD = {
  key: "dsp_brand_searches",
  label: "Brand Searches",
  thStyle: {
    width: WIDTH_124
  },
  class: ["right-embrace", "brand_interest"]
};
export const DSP_IMPRESSIONS_FIELD = {
  key: "dsp_impressions",
  label: "Impressions",
  thStyle: {
    width: WIDTH_170
  },
  class: ["inner-embrace", "delivery_quality"]
};
export const DSP_VTR_FIELD = {
  key: "dsp_vtr",
  label: "VTR",
  thStyle: {
    width: VERY_TINY_COLUMN_WIDTH
  },
  class: ["right-embrace", "delivery_quality"]
};
export const DSP_DELIVERY_RATE_FIELD = {
  key: "dsp_delivery_rate",
  label: "Delivery Rate",
  thStyle: {
    width: WIDTH_124
  },
  class: ["left-embrace", "control"]
};
export const DSP_PERCENT_NTB_CUST_FIELD = {
  key: "dsp_percent_ntb_cust",
  label: "% NTB cust.",
  thStyle: {
    width: WIDTH_124
  },
  class: ["inner-embrace", "control"]
};
export const DSP_CVR_FIELD = {
  key: "dsp_cvr",
  label: "CVR",
  thStyle: {
    width: VERY_TINY_COLUMN_WIDTH
  },
  class: ["inner-embrace", "control"]
};
export const DSP_POST_CLICK_PURCH_FIELD = {
  key: "dsp_post_click_purch",
  label: "Post Click Purch",
  thStyle: {
    width: WIDTH_124
  },
  class: ["inner-embrace", "control"]
};
export const DSP_HALO_FIELD = {
  key: "dsp_halo",
  label: "Halo",
  thStyle: {
    width: VERY_TINY_COLUMN_WIDTH
  },
  class: ["right-embrace", "control"]
};
export const DSP_CONSIDERATION_SIGNALS_FIELD = {
  key: "dsp_consideration_signals",
  label: "Consideration Signals",
  thStyle: {
    width: XXLARGE_COLUMN_WIDTH
  },
  class: ["left-embrace", "right-embrace", "objective"]
};
export const DSP_DPVR_VS_TARGET_FIELD = {
  key: "dsp_dpvr_vs_target",
  label: "DPVR vs Target",
  thStyle: {
    width: WIDTH_124
  },
  justify: "center",
  class: ["left-embrace", "efficiency"]
};
export const DSP_DPV_FIELD = {
  key: "dsp_dpv",
  label: "DPV",
  thStyle: {
    width: WIDTH_100
  },
  justify: "center",
  class: ["inner-embrace", "business_results"]
};
export const DSP_ATC_FIELD = {
  key: "dsp_atc",
  label: "ATC",
  thStyle: {
    width: WIDTH_124
  },
  class: ["right-embrace", "business_results"]
};
export const DSP_PERCENT_DPV_CLICK_FIELD = {
  key: "dsp_percent_dpv_click",
  label: "% DPV Click",
  thStyle: {
    width: WIDTH_109
  },
  class: ["right-embrace", "control"]
};
export const DSP_REPURCHASES_FIELD = {
  key: "dsp_repurchases",
  label: "Repurchases",
  thStyle: {
    width: WIDTH_170
  },
  class: ["left-embrace", "right-embrace", "objective"]
};
export const DSP_PERCENT_EXISTING_CUST_FIELD = {
  key: "dsp_percent_existing_cust",
  label: "% Existing cust",
  thStyle: {
    width: WIDTH_124
  },
  class: ["inner-embrace", "control"]
};
export const DSP_OVERVIEW_CAMPAIGN_GOAL = {
  key: "dsp_overview_campaign_goal",
  label: "",
  thStyle: {
    width: WIDTH_170
  },
  stickyColumn: true
};
export const DSP_OVERVIEW_BUDGET = {
  key: "dsp_overview_budget",
  label: "Budget",
  thStyle: {
    width: WIDTH_170
  }
};
export const DSP_OVERVIEW_SPEND = {
  key: "dsp_overview_spend",
  label: "Spend",
  thStyle: {
    width: WIDTH_170
  }
};
export const DSP_OVERVIEW_DELIVERY_RATE = {
  key: "dsp_overview_delivery_rate",
  label: "Delivery rate",
  thStyle: {
    width: SMALL_COLUMN_WIDTH
  }
};
export const DSP_OVERVIEW_OBJECTIVE = {
  key: "dsp_overview_objective",
  label: "Objective",
  thStyle: {
    width: LARGE_COLUMN_WIDTH
  }
};
export const DSP_OVERVIEW_CPA = {
  key: "dsp_overview_cpa",
  label: "CPA",
  thStyle: {
    width: TINY_COLUMN_WIDTH
  }
};
export const DSP_OVERVIEW_OPTIMIZATION_KPI = {
  key: "dsp_overview_optimization_kpi",
  label: "Optimization KPI",
  thStyle: {
    width: WIDTH_115
  }
};
export const DSP_OVERVIEW_ASSISTED_SALES = {
  key: "dsp_overview_assisted_sales",
  label: "Assisted sales",
  thStyle: {
    width: WIDTH_170
  }
};
export const DSP_OVERVIEW_ASSISTED_UNITS_SOLD = {
  key: "dsp_overview_assisted_units_sold",
  label: "Assited units sold",
  thStyle: {
    width: WIDTH_170
  }
};
export const CUSTOMER_PERIOD_FIELD = {
  key: "customer_period_agg",
  label: "Month",
  type: "date",
  class: "left",
  justify: "flex-start",
  thStyle: {
    width: WIDTH_100
  },
  stickyColumn: true
};
export const ACTIVE_CUSTOMER_12M = {
  key: "active_customers_12m",
  label: "Active Cust. 12m",
  type: "number",
  class: "left",
  justify: "flex-start",
  thStyle: {
    width: WIDTH_115
  }
};
export const MONTHLY_NET_ACQUISITION = {
  key: "monthly_net_acquisition",
  label: "Net Acquisition",
  type: "currency",
  class: "left",
  justify: "flex-start",
  thStyle: {
    width: WIDTH_150
  }
};
export const NEW_CUSTOMERS_MONTH = {
  key: "new_customers_month",
  label: "New Cust.",
  type: "number",
  class: ["acquisitions", "left-embrace"],
  justify: "flex-start",
  thStyle: {
    width: WIDTH_130
  }
};
export const PCT_NEW_CUSTOMERS = {
  key: "pct_new_customers",
  label: "Acquisition rate",
  type: "percentage",
  class: ["acquisitions", "inner-embrace"],
  justify: "flex-start",
  thStyle: {
    width: WIDTH_109
  }
};
export const CAC = {
  key: "cac",
  label: "CAC",
  type: "currency",
  class: ["acquisitions", "right-embrace"],
  justify: "flex-start",
  thStyle: {
    width: WIDTH_150
  }
};
export const CHURNED_CUSTOMERS_12M_MONTH = {
  key: "churned_customers_12m_month",
  label: "Churn",
  type: "number",
  class: ["churn", "left-embrace"],
  justify: "flex-start",
  thStyle: {
    width: WIDTH_130
  }
};
export const PCT_CHURNED_CUSTOMERS_12M = {
  key: "pct_churned_customers_12m",
  label: "Churn rate",
  type: "number",
  class: ["churn", "right-embrace"],
  justify: "flex-start",
  thStyle: {
    width: WIDTH_150
  }
};
export const REACTIVATED_CUSTOMERS_MONTH = {
  key: "reactivated_customers_month",
  label: "Reactivated Cust",
  type: "number",
  class: ["reactivation", "right-embrace", "left-embrace"],
  justify: "flex-start",
  thStyle: {
    width: WIDTH_130
  }
};
export const AVG_REVENUE_PER_ACTIVE_CUSTOMER_12M = {
  key: "avg_revenue_per_active_customer_12m",
  label: "ARPA",
  type: "currency ",
  class: ["engagement", "left-embrace"],
  justify: "flex-start",
  thStyle: {
    width: WIDTH_164
  }
};
export const AVG_AOV_12M = {
  key: "avg_aov_12m",
  label: "AOV 12m",
  type: "currency ",
  class: ["inner-embrace", "engagement"],
  justify: "flex-start",
  thStyle: {
    width: WIDTH_108
  }
};
export const AVG_PURCHASE_PER_ACTIVE_CUSTOMER_12M = {
  key: "avg_purchase_per_active_customer_12m",
  label: "#purchases 12m",
  type: "number ",
  class: ["inner-embrace", "engagement"],
  justify: "flex-start",
  thStyle: {
    width: WIDTH_168
  }
};
export const MEDIAN_TIME_BETWEEN_PURCHASES_DAYS_12M = {
  key: "median_time_between_purchases_days_12m",
  label: "Med Purch freq",
  type: "number ",
  class: ["inner-embrace", "engagement"],
  justify: "flex-start",
  thStyle: {
    width: WIDTH_124
  }
};
export const PCT_ACTIVE_CUSTOMERS_12M_WITH_2PLUS_PURCHASES = {
  key: "pct_active_customers_12m_with_2plus_purchases",
  label: ">2 purchases",
  type: "number ",
  class: ["inner-embrace", "engagement"],
  justify: "flex-start",
  thStyle: {
    width: WIDTH_96
  }
};
export const PCT_REVENUE_SUBSCRIBE_AND_SAVE_MONTH = {
  key: "pct_revenue_subscribe_and_save_month",
  label: "% SnS",
  type: "percentage ",
  class: ["engagement", "right-embrace"],
  justify: "flex-start",
  thStyle: {
    width: WIDTH_124
  }
};
export const LTV_PERIOD_FIELD = {
  key: "cohort_period",
  label: "Month",
  type: "date",
  class: "left",
  justify: "flex-start",
  thStyle: {
    width: WIDTH_100
  },
  stickyColumn: true
};
export const LTV_NEW_CUSTOMERS = {
  key: "ltv_new_customers",
  label: "New Customers",
  type: "number",
  class: [],
  justify: "flex-start",
  thStyle: {
    width: WIDTH_130
  }
};
export const LTV_CAC = {
  key: "ltv_cac",
  label: "CAC",
  type: "currency",
  class: [],
  justify: "flex-end",
  thStyle: {
    width: WIDTH_80
  }
};
export const LTV_RETENTION_RATE_MONTHLY = {
  key: "ltv_retention_rate_monthly",
  label: "R-%",
  type: "number",
  class: [],
  justify: "flex-end",
  thStyle: {
    width: WIDTH_80
  }
};
export const LTV_FIRST_ORDER = {
  key: "ltv_first_order",
  label: "First Order",
  type: "number",
  class: [],
  justify: "flex-end",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_0 = {
  key: "ltv_offset_00",
  label: "0",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_1 = {
  key: "ltv_offset_01",
  label: "1",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_2 = {
  key: "ltv_offset_02",
  label: "2",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_3 = {
  key: "ltv_offset_03",
  label: "3",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_4 = {
  key: "ltv_offset_04",
  label: "4",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_5 = {
  key: "ltv_offset_05",
  label: "5",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_6 = {
  key: "ltv_offset_06",
  label: "6",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_7 = {
  key: "ltv_offset_07",
  label: "7",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_8 = {
  key: "ltv_offset_08",
  label: "8",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_9 = {
  key: "ltv_offset_09",
  label: "9",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_10 = {
  key: "ltv_offset_10",
  label: "10",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_11 = {
  key: "ltv_offset_11",
  label: "11",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_12 = {
  key: "ltv_offset_12",
  label: "12",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_13 = {
  key: "ltv_offset_13",
  label: "13",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_14 = {
  key: "ltv_offset_14",
  label: "14",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_15 = {
  key: "ltv_offset_15",
  label: "15",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_16 = {
  key: "ltv_offset_16",
  label: "16",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_17 = {
  key: "ltv_offset_17",
  label: "17",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_18 = {
  key: "ltv_offset_18",
  label: "18",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_19 = {
  key: "ltv_offset_19",
  label: "19",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_20 = {
  key: "ltv_offset_20",
  label: "20",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_21 = {
  key: "ltv_offset_21",
  label: "21",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_22 = {
  key: "ltv_offset_22",
  label: "22",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_23 = {
  key: "ltv_offset_23",
  label: "23",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const LTV_OFFSET_24 = {
  key: "ltv_offset_24",
  label: "24",
  type: "number",
  class: [],
  justify: "center",
  thStyle: {
    "min-width": WIDTH_124
  }
};
export const BRAND_PORTFOLIO = {
  WORKSPACE: "315x",
  REVENUE_EVOLUTION_YTD: "93.33px",
  REVENUE_EVOLUTION_MTD: "93.33px",
  REVENUE_EVOLUTION_WTD: "93.33px",
  CURRENT_PERIOD: "249px",
  LAST_N_TACOS: "200px",
  LAST_N_ROAS: "200px",
  PPC_SPEND: null
};
export const LTV_PRODUCT_FIELD = {
  key: "ltv_product_name",
  label: "Product",
  justify: "flex-start",
  thStyle: {
    minWidth: XXLARGE_COLUMN_WIDTH
  },
  stickyColumn: true
};
export const LTV_PER_ASIN_NEW_CUSTOMER = {
  key: "ltv_per_asin_new_customers",
  label: "Entry Customers",
  type: "number",
  class: [],
  justify: "flex-start",
  thStyle: {
    width: WIDTH_130
  }
};
export const LTV_PER_ASIN_MULTIPLIER = {
  key: "ltv_per_asin_multiplier",
  label: "LTV multiplier",
  type: "number",
  class: [],
  justify: "flex-start",
  thStyle: {
    width: WIDTH_220
  }
};
export const LTV_PER_ASIN_BREAKDOWN = {
  key: "ltv_per_asin_breakdown",
  label: "LTV Breakdown",
  type: "number",
  class: [],
  justify: "flex-start",
  thStyle: {
    width: WIDTH_450
  }
};